import React, { useState } from "react";
import { Box, Avatar, Menu, MenuItem } from "@mui/material";

// Country data using FlagCDN SVGs (rounded via Avatar/image styles)
const countries = [
  { code: "ma", name: "Maroc", flagUrl: "https://flagcdn.com/ma.svg" },
  { code: "ga", name: "Gabon", flagUrl: "https://flagcdn.com/ga.svg" },

  { code: "sn", name: "Sénégal", flagUrl: "https://flagcdn.com/sn.svg" },
  { code: "ml", name: "Mali", flagUrl: "https://flagcdn.com/ml.svg" },
  { code: "ci", name: "Côte d'Ivoire", flagUrl: "https://flagcdn.com/ci.svg" },
];

export default function CountrySelector() {
  const [selectedCountry, setSelectedCountry] = useState(countries[0]); // Maroc as default (index 0)
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCountrySelect = (country) => {
    setSelectedCountry(country);
    handleClose();
  };

  return (
    <Box>
      <Avatar
        onClick={handleClick}
        sx={{
          width: 36,
          height: 36,
          cursor: "pointer",
          fontSize: "2rem",
          bgcolor: "background.paper",
          border: "2px solid",
          borderColor: "divider",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "all 0.2s ease-in-out",
          "&:hover": {
            borderColor: "primary.main",
            transform: "scale(1.05)",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          },
        }}
      >
        <Box
          component="img"
          src={selectedCountry.flagUrl}
          alt={selectedCountry.name}
          sx={{
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            objectFit: "cover",
          }}
        />
      </Avatar>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        PaperProps={{
          sx: {
            mt: 1,
            minWidth: "auto",
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
            borderRadius: "12px",
            py: 1,
          },
        }}
      >
        {countries.map((country) => (
          <MenuItem
            key={country.code}
            onClick={() => handleCountrySelect(country)}
            selected={selectedCountry.code === country.code}
            sx={{
              p: 1,
              minHeight: "auto",
              justifyContent: "center",
              borderRadius: "8px",
              mx: 1,
              "&.Mui-selected": {
                bgcolor: "primary.lighter",
                "&:hover": {
                  bgcolor: "primary.lighter",
                },
              },
              "&:hover": {
                bgcolor: "action.hover",
              },
            }}
          >
            <Avatar
              sx={{
                width: 28,
                height: 28,
                fontSize: "1.6rem",
                bgcolor: "background.paper",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box
                component="img"
                src={country.flagUrl}
                alt={country.name}
                sx={{
                  width: "100%",
                  height: "100%",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            </Avatar>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}
